import m2_examRegMenu from '@components/examRegMenu/m2_examRegMenu.vue'
import m1_examRegMenu from '@components/examRegMenu/m1_examRegMenu.vue'
import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
    components: {
        'm2ExamRegMenu': m2_examRegMenu,
        "m2Sidebar":m2Sidebar,
        "examRegMenu":m1_examRegMenu
    },
    data() {
        return {
            listShow: true,
            field: {},
            tip: '',
            examRegionGrades: [{
                index: 1,
                RegionId: null,
                showChose: true,
                chooseRegion: false,
                showRegionList: true,
                chooseRegionList: []
            }],
        }
    },
    methods: {
        getData: function () {
            let examRegInfo = this.$store.state.examRegInfo.examRegInfo;
            if (examRegInfo === null) {
                this.$router.push({
                    name: 'default.examReg.chooseBatch'
                });
            }
            this.$http.get(globalProvider.serviceUrl('e_reg/g/rgs')).then((data) => {
                if (data.body.code === resultCode.Success) {
                    this.examRegionGrades[0].chooseRegionList = data.body.data;
                    if (examRegInfo.region_subject_selections.region_id) {
                        this.listShow = false;
                        this.setChosedRegion(examRegInfo.region_subject_selections.path);
                        this.field = examRegInfo.region_subject_selections;
                    }
                }
            });
        },
        SelectedTitle: function (item) {
            item.chooseRegion = false;
            item.showRegionList = true;
            this.examRegionGrades.splice(item.index, this.examRegionGrades.length - item.index);
        },
        //获取页面提示信息
        getTip: function () {
            this.$http.get(globalProvider.serviceUrl('e_reg/g/sts/{key_code}'), {
                    params: {
                        key_code: tipKeyCode.region_reg_success
                    }
                })
                .then((data) => {
                    if (data.body.code === resultCode.Success) {
                        if (data.body.data != null) {
                            this.tip = data.body.data.key_value;
                        }
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message));
                    }
                })
        },
        setChosedRegion: function (data) {
            let i, j, regionNum;
            for (i of data) {
                let index = data.indexOf(i),
                    thisGrade = this.examRegionGrades[index],
                    num = 0;
                for (j of this.examRegionGrades[index].chooseRegionList) {
                    if (j.label == i) {
                        thisGrade.chooseRegion = j.value;
                        thisGrade.RegionId = j.label;
                        if (j.children.length > 0) {
                            thisGrade.showRegionList = false;
                            this.examRegionGrades.push({
                                index: index + 2,
                                showChose: true,
                                chooseRegion: false,
                                showRegionList: true,
                                chooseRegionList: j.children
                            })
                        }
                    } else {
                        num++
                    }
                }
                if (num === this.examRegionGrades[index].chooseRegionList.length) {
                    this.listShow = true;
                    break;
                }
                if (typeof (this.examRegionGrades[index + 1]) !== "undefined") {
                    if (this.examRegionGrades[index + 1].chooseRegionList.length > 0 && data.length < index + 2) {
                        this.listShow = true;
                    }
                }
            }
        },
        getRegionGradesId: function (grade, item, index) {
            if (item.children.length == 0) {
                this.examRegionGrades[grade - 1].chooseRegion = item.value;
                this.examRegionGrades[grade - 1].RegionId = item.label;
                this.listShow = false;
                let path = [];
                this.examRegionGrades.forEach((item) => {
                    path.push(item.RegionId);
                })
                this.field = {
                    region_id: item.label,
                    region_name: item.value,
                    path: path
                };
            } else {
                let thisGrade = this.examRegionGrades[grade - 1];
                let nextGrade = {
                    index: grade + 1,
                    showChose: true,
                    chooseRegion: false,
                    showRegionList: true,
                    chooseRegionList: []
                }
                thisGrade.chooseRegion = item.value;
                thisGrade.RegionId = item.label;
                thisGrade.showRegionList = false;
                nextGrade.chooseRegionList = thisGrade.chooseRegionList[index].children;
                this.examRegionGrades.push(nextGrade);
            }
        },
        regChoose: function () {
            this.listShow = true;
            this.examRegionGrades[this.examRegionGrades.length - 1].chooseRegion = false;
        },
        preStep: function () {
            this.$store.commit('setBackOrNextStep', 'back');
            let RegInfoModel = this.$store.state.examRegInfo.examRegInfo;
            if (RegInfoModel.file_info_confs.length > 0) {
                this.$router.push({
                    name: 'default.examReg.fileCollection'
                });
            } else if (RegInfoModel.pic_info_confs.length > 0) {
                this.$router.push({
                    name: 'default.examReg.imgCollection'
                });
            } else if (RegInfoModel.text_info_confs.length > 0) {
                this.$router.push({
                    name: 'default.examReg.baseCollection'
                });
            } else {
                this.$router.push({
                    name: 'default.examReg.examNotes'
                });
            }
        },
        nextStep: function () {
            if (!this.listShow) {
                this.$store.commit('setExamRegInfoItem', {
                    region_subject_selections: this.field
                });
                this.$router.push({
                    name: 'default.examReg.chooseSubject'
                });
            } else this.$alert('请选择考区', {
                confirmButtonText: '确定',
            });
        },
    },
    created: function () {
        this.$store.commit('setHeaderState', '3');
        this.getData();
        this.getTip()
    }
}